import { render, staticRenderFns } from "./RegisterAccountMobile.vue?vue&type=template&id=20bdd604"
import script from "./RegisterAccountMobile.vue?vue&type=script&lang=js"
export * from "./RegisterAccountMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports